<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>Assign Users to Site</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col" style="height: 500px">
            <app-users-grid
              [gridName]="'AssignUserSites'"
              [suppliedQueryData]="suppliedGridQueryData"
              (selectionChanged)="onSelectionChange($event)"
            ></app-users-grid>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <label class="form-label">Should Notify?</label>
            <select class="form-select" [(ngModel)]="shouldNotify">
              <option [ngValue]="true">YES</option>
              <option [ngValue]="false">NO</option>
            </select>
          </div>
          <div class="col-6">
            <label class="form-label">Is Primary?</label>
            <select class="form-select" [(ngModel)]="isPrimary">
              <option [ngValue]="true">YES</option>
              <option [ngValue]="false">NO</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col-2">
          <button type="button" class="btn btn-danger" (click)="close()">
            Cancel
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="disableSaveBtn"
            (click)="save()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
